<template>
  <div class="index">
    <div style="margin-top: 30px;margin-left: 50px">
      <div>
        <label style="font-size: 30px;">运营商三要素详版复核</label>
      </div>
      <div style="margin-top: 20px;">
        <div style="margin-top: 20px;">
          <label>手机号：</label><input type="text" v-model="param.chTel"/><br>
        </div>
        <div style="margin-top: 20px;">
          <label>身份证号：</label><input type="text" v-model="param.idNum"/><br>
        </div>
        <div style="margin-top: 20px;">
          <label>姓名：</label><input type="text" v-model="param.chName"/><br>
        </div>
      </div>
      <div>
        <button @click="GetCarousels" style="margin-top:30px;margin-left: 50px">核验</button>
      </div>

      <div style="margin-top: 30px">
        <p>核验结果: </p>
        <p style="margin-top: 10px;width: 600px">
          <textarea style="height: 200px;width:500px" readonly>{{ message }}</textarea>
        </p>
      </div>


    </div>
  </div>
</template>


<script>
import ComFooter from "@/components/footer.vue"; // 引入footer组件
import ComHeader from "@/components/header.vue"; // 引入header组件
import funList from "@/components/funList.vue"; // 引入方法组件
import {post, get, mothodGet} from "@/utils/httpUtils";

export default {
  name: "Index",
  data() {
    return {
      carousels: [], // 轮播图 list

      funListData1: "",

      funListData2: "",

      funListData3: "",

      funListDataArr: [],

      message: '',

      param: {}
    };
  },
  created() {

  },
  components: {
    // "com-header": ComHeader,
    // "com-footer": ComFooter,
    // "fun-list": funList,
  },
  methods: {
    // 获取 轮播图
    GetCarousels() {
      console.info(this.param)
      this.param.token = "8dhADsF0DwP673XJ5FitcZ6jwe4MQ08p4s5BBKnaMZ81RaA35dhcjKDTzQhrFHYp"
      mothodGet("", this.param).then((res) => {
        console.info(res.data)
        console.info(res.data.result)
        let data = res.data;

        this.message = data;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.el-carousel__item img {
  width: 100%;
  height: 100%;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

// title
.titleP {
  text-align: center;
  font-size: 28px;
  color: #999999;
  padding: 30px 0;

  span {
    padding: 0 30px;
    font-weight: bold;
    color: #043649;
  }
}

.contentBox {
  padding-bottom: 20px;

  // 公司简介
  .index_main2_container {
    width: 1200px;
    margin: 0 auto;
    padding: 0 60px 60px 60px;
    background: #fff;
    box-sizing: border-box;
    border-radius: 8px;
    margin-top: 20px;

    .titleP {
      padding-bottom: 73px;
    }

    .primary_box {
      display: flex;
      justify-content: space-between;

      .left {
        margin-right: 60px;
        font-weight: 400;
        font-size: 14px;

        .secondary_title {
          font-size: 24px;
          font-weight: bold;
          color: #043649;
          line-height: 30px;
          margin-bottom: 30px;
        }

        .index_main2_content {
          line-height: 20px;
          margin-bottom: 15px;
          text-align: justify;
          color: #043649;
        }
      }

      img {
        border: none;
        vertical-align: middle;
      }

      .right {
        width: 400px;

        img {
          width: 100%;
        }
      }
    }
  }

  // 服务
  .security {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 40px;
    background: #fff;
    margin-top: 20px;
    border-radius: 8px;

    .titleP {
      padding-bottom: 20px;
    }

    .security-des {
      font-size: 12px;
      color: #043649;
      line-height: 20px;
      text-align: center;
    }

    .security-logo {
      margin-top: 30px;
      display: flex;
      justify-content: space-around;

      ul,
      li {
        list-style: none;
      }

      .security-logo-item {
        .security-logo-item-pic {
          width: 160px;
          height: 90px;
          text-align: center;
        }

        img {
          border: 0;
          vertical-align: middle;
        }

        .security-logo-item-pic160 {
          img {
            width: 160px;
            height: 90px;
          }
        }

        .security-logo-item-pic161 {
          img {
            width: 70px;
            height: 70px;
          }
        }

        .security-logo-item-pic73 {
          display: table-cell;
          vertical-align: middle;

          img {
            width: 73px;
            height: 70px;
          }
        }

        .security-logo-item-name {
          font-size: 12px;
          line-height: 18px;
          color: #181818;
          text-align: center;
        }
      }
    }
  }
}
</style>
